import { render, staticRenderFns } from "./password-editor.vue?vue&type=template&id=185199f8"
import script from "./password-editor.vue?vue&type=script&lang=js"
export * from "./password-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports